'use client';

import { createContext } from 'react';

import type { FormFieldContextInterface } from '../types/form-field.types';

export const FormFieldContext = createContext<FormFieldContextInterface>({});

FormFieldContext.displayName = 'FormField.Context';
